import 'styles/cart/sidebar-line-item.scss';

import React from 'react';

import propTypes from 'propTypes';
import PriceSpan from 'common/components/formatters/PriceSpan';
import QuantityInput from 'common/components/QuantityInput';

import { TranslatedMessage } from 'common/components/Intl';

const FLAVOR_OPTION_TYPE_NAME = 'flavor';
const NICOTINE_OPTION_TYPE_NAME = 'nicotine_strength_percent';

export default class Sidebar extends React.Component {
  static propTypes = {
    item: propTypes.object.isRequired,
    quantityProcessing: propTypes.number,
    handleQuantityChange: propTypes.func.isRequired,
    variants: propTypes.array.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    discountPerItem: propTypes.number.isRequired,
  };

  handleQuantityChange = quantity => {
    this.props.handleQuantityChange({ quantity, lineItem: this.props.item });
  };

  render() {
    const {
      item,
      variants,
      isMembershipOrder,
      discountPerItem,
      quantityProcessing,
    } = this.props;
    const quantity = Number.isInteger(quantityProcessing)
      ? quantityProcessing
      : item.quantity;
    const itemOptions = item.options || [];
    const flavorOption = itemOptions.find(
      option => option.type_name === FLAVOR_OPTION_TYPE_NAME
    );
    const nicotinePercent = itemOptions.find(
      option => option.type_name === NICOTINE_OPTION_TYPE_NAME
    );
    const nicotinePercentValue = nicotinePercent
      ? nicotinePercent.value_presentation
      : nicotinePercent;
    const variant = variants.find(v => v.sku === item.sku);
    const displayName = flavorOption
      ? flavorOption.value_presentation
      : variant.name;

    const originalPrice = parseFloat(item.price) * item.quantity;
    const totalPrice = originalPrice - discountPerItem;

    let origPriceComponent;
    if (discountPerItem > 0) {
      origPriceComponent = (
        <PriceSpan
          className="SidebarLineItem__price--original"
          amount={originalPrice}
        />
      );
    }

    const color = isMembershipOrder && variant.is_subscribable ? 'toupe' : null;

    const disableIncrement =
      variant.subscription_commitment_months > 0 && quantity >= 0;

    return (
      <div className="SidebarLineItem">
        <img className="SidebarLineItem__image" src={item.image} />
        <div className="SidebarLineItem__content">
          <div className="SidebarLineItem__row--top">
            <div className="SidebarLineItem__name">
              {displayName}&nbsp;
              <span className="gray-dark">{nicotinePercentValue}</span>
            </div>

            <div className="SidebarLineItem__quantity">
              <QuantityInput
                color={color}
                value={quantity}
                disableIncrement={disableIncrement}
                onChange={this.handleQuantityChange}
              />
            </div>
          </div>

          <div className="SidebarLineItem__row--bottom">
            <div className="SidebarLineItem__price-label">
              <TranslatedMessage id={'cart.line_item.price'} />
            </div>

            {origPriceComponent}
            <div className="SidebarLineItem__total-price">
              <PriceSpan amount={totalPrice} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/sidebar/LineItem.js